import { useCallback } from "react";
import { useSelector } from "react-redux";


import userImg from "../../assets/user.webp";
import clsx from "clsx";
import { HiOutlineRefresh } from "react-icons/hi";

import { useUsers } from "../../hooks/useUsers";
import { usePool } from "../../hooks/usePool";
export const UserProfile = ({ showEditProfile }) => {
  const { getMainPool } = usePool();
  const { getUser } = useUsers();

  const getData = useCallback(async () => {
    await getUser();
    await getMainPool();
  }, [getUser, getMainPool]);

  const user = useSelector((state) => state.user);
  return (
    <div
      className='flex flex-col w-full items-center h-[100px] mt-5 mb-2
    '>
      <div
        className={clsx(
          "rounded bg-[rgba(255,255,255,0.8)] rounded-full w-[72px] h-[72px] items-center flex",
          {
            "p-2": !user.profileImg,
          },
        )}
        onClick={showEditProfile}>
        <img
          src={user.profileImg || userImg}
          alt='User'
          className={clsx("", {
            "w-[72px] h-[72px] object-contain rounded-full": user.profileImg,
          })}
        />
      </div>
      <section className='flex flex-col items-center mt-2 z-30'>
        <span className='text-[20px]'>{user.name}</span>
        <span className='text-[12px] text-gray-400'>{user.email}</span>
        <button className='text-white/70 flex items-center bg-[rgb(23,43,69,0.5)] border-[1px] border-white/40 rounded-md  py-[6px] px-3 text-[10px] mt-5'
          onClick={getData}>
          Actualizar mi perfil
          <HiOutlineRefresh className='h-4 w-4 ml-3' />
        </button>
      </section>
    </div>
  );
};
